class ContactFinder {
  constructor() {
    this.init = this.init.bind(this);
    this.scrollToContacts = this.scrollToContacts.bind(this);
    this.init();
  }

  init() {
    const contactFinderContainer = document.querySelector('[data-contact-finder]');
    const dropdown = document.querySelector('.contact-finder__dropdown');
    const dropdownHeader = dropdown.querySelector('.contact-finder__dropdown-header');
    const dropdownLinks = dropdown.querySelectorAll('.contact-finder__dropdown-content a');
    const mapLinks = contactFinderContainer.querySelectorAll('svg a');

    if (contactFinderContainer && dropdown && dropdownHeader && dropdownLinks && mapLinks) {
      dropdownHeader.addEventListener('click', function() {
        dropdown.classList.toggle('contact-finder__dropdown--opened');
      });

      dropdownLinks.forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();

          dropdown.classList.remove('contact-finder__dropdown--opened');
          this.scrollToContacts(element);
        });
      });

      mapLinks.forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();

          dropdown.classList.remove('contact-finder__dropdown--opened');
          this.scrollToContacts(element);
        });
      });
    }
  }

  scrollToContacts(link) {
    let href = link.getAttribute('href');
    if (link.hasAttribute('xlink:href')) {
      href = link.getAttribute('xlink:href')
    }

    if (href) {
      const targetElement = document.querySelector(href);

      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();

        window.scrollTo({
          top: rect.top - 200,
          behavior: 'smooth'
        });
      }
    }
  }
}

export default new ContactFinder();
